<template>
    <div id="production" :class="[$mq]">
        <div id="sidebar" :class="{ 'collapsed': !sidebarExpanded }">
            <Sidebar :categories="categories" :date="date" :summary="summary" @selectDate="selectDate" @selectCategory="selectCategory" @toggle="toggleSidebar" :expanded="forecast && forecast.defrost !== false && !configuration" :selected="!forecast" :reset="!configuration" :displayed="sidebarExpanded"></Sidebar>
        </div>

        <div id="board" :class="{ 'collapsed': !sidebarExpanded }">
            <Topbar id="topbar" :summary="summary"></Topbar>
            <div class="main-content">
                <Configuration v-if="configuration" :types="[6]" />
                <Init v-else-if="bSelectDate" :date="date"></Init>
                <productionView v-else ref="productionView" :date="date" :products="products"> </productionView>
            </div>
            <NoticeToast
                v-if="phaseNotice && showProduction"
                :key="phaseNotice.key"
                :title="$t(phaseNotice.titleKey)"
                :message="$t('pls.phaseNotice.subtitle')"
                :duration="phaseNotice.durationMs"
                :sound="phaseNotice.sound"
                :variant="phaseNotice.variant"
                :close-label="$t('popup.default.text_close')"
                @close="phaseNotice = null"
            />
            <div v-if="debugPls && showProduction" class="pls-phase-preview">
                <button type="button" class="pls-phase-preview__button" @click="previewPlsPhase('escalation')">Probar escalada</button>
                <button type="button" class="pls-phase-preview__button" @click="previewPlsPhase('deescalation')">Probar desescalada</button>
                <label v-if="salesRampSlots.length" class="pls-phase-preview__hour">
                    <span class="pls-phase-preview__hour-label">Hora</span>
                    <select class="pls-phase-preview__select" @change="previewSalesRampSlot">
                        <option value="">Selecciona hora</option>
                        <option v-for="slot in salesRampSlots" :key="slot" :value="slot">{{ slot }}</option>
                    </select>
                </label>
            </div>
        </div>
    </div>
</template>

<script>
import Sidebar from '../components/domain/pls/sidebar.vue'
import Topbar from '../components/domain/pls/topbar.vue'
import Configuration from '../components/domain/production/Configuration.vue'
import Init from '../components/domain/pls/init.vue'
import productionView from '../components/domain/pls/productionView.vue'
import NoticeToast from '../components/layout/NoticeToast.vue'
import { resolvePlsPhaseNotice, resolveSalesRampAction, salesRampSlotKey } from '../utils/plsPhaseNotice'
import { filter } from 'lodash'

export default {
    components: {
        Sidebar,
        Configuration,
        Init,
        productionView,
        Topbar,
        NoticeToast
    },
    name: 'Pls',
    data() {
        return {
            date: moment().format('YYYY-MM-DD'),
            isExpanded: false,
            firstLoad: true,
            loadInterval: null,
            userInteraction: false,
            refreshInterval: null,
            sidebarExpanded: localStorage.getItem('sidebarExpanded') ? localStorage.getItem('sidebarExpanded') == 'true' : true,
            phaseNotice: null,
            noticeSequence: 0,
            lastSalesRampSlot: null,
            debugPls: localStorage.getItem('debug_pls') === '1'
        }
    },
    computed: {
        categories() {
            var types = [6]
            const allProducts = this.$store.getters['production/getProducts']
            var filteredProducts = filter(allProducts, (product) => types.includes(product.type))

            const categories = this.$store.getters['production/getCategories']
            const productsCategories = Object.values(filteredProducts).map((product) => product.category)
            return Object.values(categories).reduce((acc, category) => {
                if (productsCategories.includes(category.id)) {
                    acc[category.id] = category
                }
                return acc
            }, {})
        },
        category() {
            return this.$store.getters['production/getSelectedCategory']
        },
        products() {
            let data = this.$store.getters['production/getProducts']
            let products = []
            for (var idx in data) {
                var product = data[idx]
                let show = false
                if (!this.category) {
                    show = true
                } else if (this.category && product.category == this.category.id) {
                    show = true
                }

                if (show && product.status) {
                    products.push(product)
                }
            }
            return products
        },
        forecast() {
            return this.$store.getters['production/getForecast']
        },
        bSelectDate() {
            return this.forecast === false || Object.keys(this.forecast).length == 0 || this.forecast.defrost === false
        },
        summary() {
            if (this.forecast.summary) {
                return this.forecast.summary
            }
            return {}
        },
        configuration() {
            return this.$store.getters['production/getConfiguration']
        },
        showProduction() {
            return !this.configuration && !this.bSelectDate
        },
        salesRamp() {
            let ramp = this.forecast && this.forecast.sales_ramp

            if (typeof ramp === 'string') {
                try {
                    ramp = JSON.parse(ramp)
                } catch (_) {
                    return null
                }
            }

            if (!ramp || typeof ramp !== 'object' || Array.isArray(ramp)) {
                return null
            }

            return ramp
        },
        salesRampSlots() {
            if (!this.salesRamp) {
                return []
            }

            return Object.keys(this.salesRamp).sort()
        }
    },
    methods: {
        load(source = 'user') {
            let self = this

            self.selectCategory(false)

            // Select today date based on the schedule

            if(!this.userInteraction) {
                this.date = moment().format('YYYY-MM-DD')
            }

            let config = this.$store.getters['login/getConfig']
            let start_hour = 8
            if (config && config.schedule && config.schedule.schedule) {
                let schedule = config.schedule.schedule
                let dayMap = { 'lun.': 'm', 'mar.': 't', 'mie.': 'w', 'jue.': 'r', 'vie.': 'f', 'sáb.': 's', 'dom.': 'u' }
                let day = dayMap[moment().format('ddd').toLowerCase()]
                if (schedule[day] && schedule[day].c && schedule[day].c.s) {
                    start_hour = parseInt(schedule[day].c.s.split(':')[0])
                }
            }

            if(moment().isSame(moment(), 'day') && moment().hour() < start_hour) {
                this.date = moment().subtract(1, 'days').format('YYYY-MM-DD')
            }

            if (this.products.length == 0) {
                this.$overlay.loading()
                this.$store.dispatch('production/loadData').then(() => {
                    self.selectCategory(false)
                    self.$overlay.hide()
                    this.loadForecast(source)
                })
            } else {
                this.loadForecast(source)
            }
        },
        loadForecast(source = 'user') {
            let self = this
            if(this.firstLoad) {
                this.$overlay.loading()
                this.$store.dispatch('production/loadForecast', { date: this.date, source }).then(() => {
                    self.$overlay.hide()
                })
            }

        },
        selectCategory(category) {
            var self = this
            self.$overlay.loading()
            this.$store.commit('production/selectCategory', category)
            self.$overlay.hide()
        },
        selectDate(date) {
            if(this.date != date) {
                this.firstLoad = true
                this.date = moment(date).format('YYYY-MM-DD')
                this.loadForecast('user')
                this.userInteraction = true
            }
        },
        async refreshPage() {
            const hasConnection = fnCheckConnection()
            if (hasConnection) {
                window.location.reload()
            }
        },
        toggleSidebar() {
            this.sidebarExpanded = !this.sidebarExpanded
            localStorage.setItem('sidebarExpanded', this.sidebarExpanded)
        },
        previewPlsPhase(phase) {
            const notice = resolvePlsPhaseNotice({ previousPhase: null, nextPhase: phase })

            if (!notice) {
                return
            }

            this.noticeSequence += 1
            this.phaseNotice = {
                ...notice,
                key: this.noticeSequence
            }
        },
        showSalesRampNotice(slotKey, remember) {
            if (!slotKey) {
                return
            }

            if (remember && slotKey === this.lastSalesRampSlot) {
                return
            }

            const action = resolveSalesRampAction(this.salesRamp, slotKey)

            if (!action) {
                return
            }

            if (remember) {
                this.lastSalesRampSlot = slotKey
            }

            this.previewPlsPhase(action)
        },
        checkSalesRampClock() {
            if (!this.showProduction) {
                return
            }

            const now = new Date()
            const minutes = now.getMinutes()

            if (minutes !== 0 && minutes !== 30) {
                return
            }

            this.showSalesRampNotice(salesRampSlotKey(now), true)
        },
        previewSalesRampSlot(event) {
            const select = event.target
            const slotKey = select.value

            select.value = ''

            if (!slotKey) {
                return
            }

            this.showSalesRampNotice(slotKey, false)
        }
    },
    created() {
        this.load('user')
        this.loadInterval = setInterval(() => {
            const minutes = new Date().getMinutes()
            if (minutes === 0 || minutes === 30) {
                this.checkSalesRampClock()
            }
            if (minutes === 0 || minutes === 15 || minutes === 30 || minutes === 45 ) {
                this.firstLoad = true
                this.load('auto')
            }
        }, 60 * 1000)

        this.refreshInterval = setInterval(() => {
            this.refreshPage()
        }, 4 * 60 * 60 * 1000)
    },
    beforeDestroy() {
        if (this.loadInterval) {
            clearInterval(this.loadInterval)
        }
        if (this.refreshInterval) {
            clearInterval(this.refreshInterval)
        }
        window.previewPlsPhase = undefined
    },
    mounted() {
        window.previewPlsPhase = (phase) => {
            this.previewPlsPhase(phase)
        }
    },
    watch: {}
}
</script>

<style lang="scss" scoped>
#production {
    display: flex;
    x-justify-content: space-around;
    x-align-items: stretch;
    width: 100%;

    #sidebar {
        width: 300px;
        flex: 0 0 300px;
        height: 100%;
        background-color: #fff;

        position: absolute;

        &.collapsed {
            width: 57px;
            background-color: transparent;
        }
    }
    #board {
        padding: 16px;
        border-radius: 4px;
        width: calc(100% - 300px);
        flex: 0 0 calc(100% - 300px);
        position: absolute;
        left: 300px;
        height: 100%;
        min-height: 0;
        min-width: 0;

        &.collapsed {
            width: calc(100% - 60px);
            left: 60px;
        }

        header {
            &.header-container {
                margin-bottom: 8px;
            }
        }

        .pls-phase-preview {
            position: absolute;
            z-index: 4;
            top: 16px;
            right: 16px;
            display: flex;
            gap: 8px;

            &__button {
                padding: 8px 12px;
                border: 0;
                border-radius: 4px;
                background-color: $main-text;
                color: #fff;
                font-family: $text-bold;
                cursor: pointer;
            }

            &__select {
                padding: 8px 12px;
                border: 0;
                border-radius: 4px;
                background-color: #fff;
                color: $main-text;
                font-family: $text;
                cursor: pointer;
            }

            &__hour {
                display: flex;
                align-items: center;
                gap: 8px;
            }

            &__hour-label {
                color: $main-text;
                font-family: $text-bold;
            }
        }

        .main-content {
            width: 100%;
            height: calc(100%);
            //overflow-y: auto;
            // position: absolute;
            // height: calc(100% - 50px - 16px);

            &.without-tab {
                height: calc(100%);
            }

            .working-on {
                @include display-flex();
                @include align-items();
                @include justify-content();
                padding: 1rem;
                width: 100%;
                height: 90%;
                text-transform: uppercase;
                font-family: $text-bold;

                .image {
                    @include background($image: img('alexhead_08.svg'));
                    display: block;
                    width: 100px;
                    height: 100px;
                }
            }
        }
    }
}

@media (orientation: portrait) {
    #production {
        #sidebar {
            display: none;
        }

        #board {
            width: 100% !important;
            flex: 100%;
            position: relative;
            left: 0px !important;
            height: 100%;
        }
    }
}

@media (orientation: landscape) {
    #production {
        #topbar {
            display: none;
        }
    }
}
</style>
